export default function PHP_preg_replace_callback_array() {
  return (
    <div>
      <h1>PHP_preg_replace_callback_array</h1>
    </div>
  );
}
